const selections = {
  make: '',
  series: '',
  chassis: '',
  model: '',
  engine: '',
  drivetrain: '',
  year: ''
}

const info = {
  selectedCar: '',
  collectionHandle: ''
}

const mods = {
  engineMods: [],
  exhaustOrDownPipeMods: [],
  suspensionMods: [],
  exteriorMods: [],
  lightingMods: [],
  interiorMods: [],
  brakeMods: [],
  transmissionMods: [],
  otherModsOrInfo: [],
  plannedFutureMods: [],
}

const wheels = {
  wheelBrandOrModel: '',
  tireBrandOrModel: '',
  wheelsAndTiresSameSize: true,
  sameSizeWheels: {
    diameter: '',
    width: '',
    offset: '',
    tireWidth: '',
    tireAspectRatio: ''
  },
  differentWheels: {
    diameterFront: '',
    widthFront: '',
    offsetFront: '',
    tireWidthFront: '',
    tireAspectRatioFront: '',
    diameterRear: '',
    widthRear: '',
    offsetRear: '',
    tireWidthRear: '',
    tireAspectRatioRear: ''
  },
  frontWheelSpacers: '',
  rearWheelSpacers: ''
}

let images = [];
let photographerIg = '';

const deparam = () => {
  let queryString = {};
  let uri = window.location.search;
  uri.replace(new RegExp("([^?=&]+)(=([^&#]*))?", "g"), ($0, $1, $2, $3) => queryString[$1] = decodeURIComponent($3.replace(/\+/g, '%20')));
  return queryString;
}

let activeStep = parseInt(deparam().step) || 1;

const ID = deparam().car_profile;

const GET_PROFILE = `
  query profile($id: ID!) {
    profile(id: $id) {
      make
      series
      chassis
      model
      engine
      drivetrain
      year
      selectedCar
      collectionHandle
      status
      
      engineMods {
        value
      }
      exhaustOrDownPipeMods {
        value
      }
      suspensionMods {
        value
      }
      exteriorMods {
        value
      }
      lightingMods {
        value
      }
      interiorMods {
        value
      }
      brakeMods {
        value
      }
      transmissionMods {
        value
      }
      otherModsOrInfo {
        value
      }
      plannedFutureMods {
        value
      }
      images
      photographerIg
      wheelBrandOrModel
      tireBrandOrModel
      wheelsAndTiresSameSize
      sameSizeWheels {
        diameter
        width
        offset
        tireWidth
        tireAspectRatio
      }
      differentWheels {
        diameterFront
        widthFront
        offsetFront
        tireWidthFront
        tireAspectRatioFront
        diameterRear
        widthRear
        offsetRear
        tireWidthRear
        tireAspectRatioRear
      }
      frontWheelSpacers
      rearWheelSpacers
    }
  }
`;

const SAVE_PROFILE = `
  mutation editProfile($id: ID!, $input: ProfileInput!) {
    editProfile(id: $id, input: $input)
  }
`;

const ADD_IMAGE = `
  mutation addImage($id: ID!, $image: String!, $unwatermarkedImage: String!) {
    addImage(id: $id, image: $image, unwatermarkedImage: $unwatermarkedImage)
  }
`;

const REMOVE_IMAGE = `
  mutation removeImage($id: ID!, $image: String!) {
    removeImage(id: $id, image: $image)
  }
`;

const ADD_MOD = `
  mutation addMod($id: ID!, $input: ModInput!) {
    addMod(id: $id, input: $input)
  }
`;

const ADD_MAINT = `
  mutation addMaint($id: ID!, $input: MaintenanceInput!) {
    addMaint(id: $id, input: $input)
  }
`;

const REMOVE_MOD = `
  mutation removeMod($id: ID!, $input: ModInput!) {
    removeMod(id: $id, input: $input)
  }
`;

const HOST = window.theme.host;
const headers = {
  customeremail: window.theme.customerEmail,
  customerhashedid: window.theme.customerHashedID,
  shop: window.theme.shop
};
const loader = document.querySelector('.CarProfile__loader');
const imagesLoader = document.querySelector('.CarProfile__photosLoader');
const main = document.querySelector('.CarProfileBuilder');
const header = document.querySelector('.CarProfile__signUp');
let watermark;

const getProfile = async () => {
  if (!window.theme.customerEmail) {
    return window.location.replace('/pages/car-profile-builder-create-an-account');
  }
  if (!ID) {return window.location.replace('/account');}
  try {
    const response = await axios.post(`${HOST}/customer_graphql`, {query: GET_PROFILE, variables: {id: ID}}, {headers});
    const profile = response.data.data.profile;
    if (profile.status === 'published') {
      return window.location.replace(`/pages/car-profile-builder-edit?car_profile=${ID}`);
    }
    Object.keys(selections).forEach(key => selections[key] = profile[key]);
    Object.keys(info).forEach(key => info[key] = profile[key]);
    Object.keys(mods).forEach(key => mods[key] = profile[key]);
    Object.keys(wheels).forEach(key => wheels[key] = profile[key]);
    images = profile.images;
    photographerIg = profile.photographerIg;
    if (activeStep === 4 || profile.status === 'submitted' || profile.status === 'resubmitted') {
      if (profile.status === 'resubmitted') {
        header.querySelector('.CarProfile__carImage').style.display = 'none';
        header.querySelector('.CarProfile__signUp--creditGraphic').style.display = 'none';
        document.querySelector('.CarProfile__yearTitle').textContent = selections.year + ' ' + info.selectedCar;
      }
      if (images.length > 0) {
        activeStep = 4;
        setStepFour();
      } else {
        activeStep = 1;
      }
      if (profile.status === 'submitted' || profile.status === 'resubmitted') {
        document.querySelector('.CarProfile__summarySection--termsAndConditions').remove();
        document.querySelector('.CarProfile__btns').remove();
      }
      setActiveStep();
    }
    setCarDetails();
    Object.keys(mods).forEach(key => setModList(key));
    setWheelSelections();
    imagesLoader.classList.add('active');
    setLoading(false);
    setWaterMark();
    if (photographerIg) {
      document.getElementById('photographerIgName').value = photographerIg;
    }
    await setImageView();
    imagesLoader.classList.remove('active');    
    
  } catch(e) {console.log('Error loading profile', e);}
}

const setWaterMark = async () => {
  const watermarkImage = new Image();
  watermarkImage.src = window.theme.watermark;
  watermarkImage.crossOrigin = 'Anonymous';
  await new Promise((resolve, reject) => watermarkImage.onload = () => resolve());
  watermark = watermarkImage;
}

const saveProfile = async input => {
  try {
    await axios.post(`${HOST}/customer_graphql`, {query: SAVE_PROFILE, variables: {id: ID, input}}, {headers});
  } catch(e) {console.log('Error saving profile', e)}
}

const setCarDetails = () => {
  const keys = Object.keys(selections);
  keys.forEach((key, index) => {
    const value = selections[key];
    if (value) {
      document.querySelector(`.detailDrop[data-select="${key}"]`).classList.add('active');
      document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect p`).textContent = value;
      
      const selectionLink = document.querySelector(`.detailDrop[data-select="${key}"] .detailDropOptionSelection[data-value="${value}"]`);
      if (selectionLink) {
        selectionLink.classList.add('active');
      }
      
      const nextSelection = keys[index + 1];
      if (nextSelection) {
        if (nextSelection !== 'year') {
          let nextSelections = [];
          const currentSelections = Object.values(selections).slice(0, index + 1);
          const allNextSelections = carModelsArray.filter(arr => currentSelections.every((val, i) => arr[i] === val));
          allNextSelections.forEach(arr => {
            const value = arr[currentSelections.length];
            if (nextSelections.indexOf(value) === -1) {
              nextSelections.push(value);
            }
          });
          const container = document.querySelector(`.detailDrop[data-select="${nextSelection}"] .detailDropOptions`);
          nextSelections.forEach(val => {
            const a = document.createElement('a');
            a.dataset.value = val;
            a.textContent = val;
            a.className = 'detailDropOptionSelection';
            container.append(a);
            if (nextSelections.length === 1  && !nextSelections[0]) {
              document.querySelector(`.detailDrop[data-select="${nextSelection}"]`).classList.add('blank');
            }
          });
        }
      }
    }
  });
  setCarImage();
}

const setWheelSelections = () => {
  if (!wheels.wheelsAndTiresSameSize) {
    document.querySelector('.wheelDropOptionSelection[data-value="yes"]').classList.remove('active');
    document.querySelector('.wheelDropOptionSelection[data-value="no"]').classList.add('active');
    document.querySelector('.wheelDrop[data-option="wheelsAndTiresSameSize"] .wheelDropSelect p').textContent = 'No, Staggered Fitment';
    document.querySelector('.sameSizeWheels').style.display = 'none';
    document.querySelector('.staggeredWheels').style.display = 'block';
  }
  if (wheels.wheelBrandOrModel) {
    document.querySelector('.wheelInput input[data-value="wheelBrandOrModel"]').value = wheels.wheelBrandOrModel;
  }
  if (wheels.tireBrandOrModel) {
    document.querySelector('.wheelInput input[data-value="tireBrandOrModel"]').value = wheels.tireBrandOrModel;
  }
  if (wheels.frontWheelSpacers) {
    document.querySelector('.wheelDrop[data-option="frontWheelSpacers"] .wheelDropSelect p').textContent = wheels.frontWheelSpacers;
    document.querySelector(`.wheelDrop[data-option="frontWheelSpacers"] .wheelDropOptionSelection[data-value="${wheels.frontWheelSpacers}"]`).classList.add('active');
  }
  if (wheels.rearWheelSpacers) {
    document.querySelector('.wheelDrop[data-option="rearWheelSpacers"] .wheelDropSelect p').textContent = wheels.rearWheelSpacers;
    document.querySelector(`.wheelDrop[data-option="rearWheelSpacers"] .wheelDropOptionSelection[data-value="${wheels.rearWheelSpacers}"]`).classList.add('active');
  }

  Object.keys(wheels.sameSizeWheels).forEach(key => {
    const value = wheels.sameSizeWheels[key];
    if (value) {
      if (key === 'offset') {
        document.querySelector(`.wheelInput input[data-value="${key}"]`).value = value;
      } else {
        document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropSelect p`).textContent = value;
        document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropOptionSelection[data-value="${value}"]`).classList.add('active');
      }
    }
  });
  Object.keys(wheels.differentWheels).forEach(key => {
    const value = wheels.differentWheels[key];
    if (value) {
      if (key === 'offsetFront' || key === 'offsetRear') {
        document.querySelector(`.wheelInput input[data-value="${key}"]`).value = value;
      } else {
        document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropSelect p`).textContent = value;
        document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropOptionSelection[data-value="${value}"]`).classList.add('active');
      }
    }
  });
}

const setLoading = loading => {
  if (loading) {
    loader.classList.add('active');
    main.style.display = 'none';
    header.style.display = 'none';
    return;
  }
  loader.classList.remove('active');
  main.style.display = 'block';
  header.style.display = 'flex';
}

const setStepFour = () => {
  document.querySelectorAll('.CarProfile__summarySection--modsList').forEach(list => {
    const container = list.closest('.CarProfile__summarySection-mods');
    const mod = list.dataset.mods;
    list.innerHTML = '';
    if (mods[mod].length === 0) {
      container.style.display = 'none';
    } else {
      container.style.display = 'block';
    }
  });
  document.querySelector('.CarProfile__summarySection--images').innerHTML = '';
  Object.keys(mods).forEach(key => {
    const container = document.querySelector(`.CarProfile__summarySection--modsList[data-mods="${key}"]`);
    mods[key].forEach(mod => {
      const li = document.createElement('li');
      li.textContent = mod.value;
      container.append(li);
    });
  });

  document.querySelectorAll('.wheelInfoLine').forEach(wheelInfoLine => {
    const valueContainer = wheelInfoLine.querySelector('.wheelInfoLine__value p');
    let wheelValue = wheelInfoLine.dataset.wheelValue;
    let wheelObj = wheels;
    if (wheelValue.indexOf('.') > -1) {
      const wheelKey = wheelValue.split('.')[0];
      wheelValue = wheelValue.split('.')[1];
      wheelObj = wheels[wheelKey];
    }
    const wheelOptionValue = wheelObj[wheelValue];
    if (wheelOptionValue) {
      valueContainer.textContent = wheelOptionValue;
      wheelInfoLine.style.display = 'flex';
    } else {
      wheelInfoLine.style.display = 'none';
      valueContainer.textContent = '';
    }
  });
  document.querySelectorAll('.wheelsInfo').forEach(wheelSection => {
    const values = [];
    wheelSection.querySelectorAll('.wheelInfoLine__value p').forEach(line => values.push(line.textContent));
    const noValues = values.every(i => !i);
    if (noValues) {
      wheelSection.style.display = 'none';
    } else {
      const sameSize = wheels.wheelsAndTiresSameSize;
      const isSameSizeContainer = wheelSection.classList.contains('wheelsInfo__sameSize');
      const isFrontContainer = wheelSection.classList.contains('wheelsInfo__front');
      const isRearContainer = wheelSection.classList.contains('wheelsInfo__rear');
      if (isSameSizeContainer || isFrontContainer || isRearContainer) {
        const display = (sameSize && isSameSizeContainer) || (!sameSize && isFrontContainer || !sameSize && isRearContainer);
        if (display) {
          wheelSection.style.display = 'block';
        } else {
          wheelSection.style.display = 'none';
        }
      } else {
        wheelSection.style.display = 'block';
      }
    }
  });

  setStepFourPhotos();
}

const setStepFourPhotos = async (index = 0) => {
  if (index >= images.length) {return;}
  const container = document.querySelector('.CarProfile__summarySection--images');
  const div = document.createElement('div');
  div.classList = 'CarProfile__summarySection--image';
  const displayImg = new Image();
  displayImg.src = HOST + images[index];
  div.innerHTML = `<div class="summaryImage"><img src="${displayImg.src}"></div>`;
  container.append(div);
  setStepFourPhotos(index + 1);
}

const setActiveStep = () => {
  document.querySelectorAll('.CarProfile__step').forEach(step => step.style.display = 'none');
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  document.querySelector(`.CarProfile__step[data-step="${activeStep}"]`).style.display = 'block';
  if (activeStep === 1) {
    document.querySelectorAll('.prev, .completeSubmission').forEach(button => button.style.display = 'none');
    document.querySelectorAll('.next').forEach(button => button.style.display = 'block');
  } else if (activeStep === 2 || activeStep === 3) {
    document.querySelectorAll('.completeSubmission').forEach(button => button.style.display = 'none');
    document.querySelectorAll('.prev, .next').forEach(button => button.style.display = 'block');
  } else if (activeStep == 4) {
    document.querySelectorAll('.next').forEach(button => button.style.display = 'none');
    document.querySelectorAll('.prev, .completeSubmission').forEach(button => button.style.display = 'block');
  }
}

const pushToHistory = () => {
  let historyUrl = `?car_profile=${ID}`;
  if (activeStep > 1) {
    historyUrl += `&step=${activeStep}`
  }
  history.pushState({car_profile: ID, step: activeStep}, 'car profile builder', historyUrl);
}

const makeWheelSelection = (key, value) => {
  document.querySelectorAll(`.wheelDrop[data-option="${key}"] .wheelDropOptionSelection`).forEach(a => a.classList.remove('active'));
  document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropOptionSelection[data-value="${value}"]`).classList.add('active');
  document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropSelect`).classList.remove('open');
  document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropOptions`).style.height = 0;
  if (key === 'wheelsAndTiresSameSize') {
    document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropSelect p`).textContent = value === 'yes' ? 'Yes, Same Size' : 'No, Staggered Fitment';
  } else {
    document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropSelect p`).textContent = value;
  }
  let save = {};
  if (key === 'wheelsAndTiresSameSize') {
    wheels.wheelsAndTiresSameSize = value === 'yes' ? true : false;
    save[key] = wheels[key];
    if (wheels.wheelsAndTiresSameSize) {
      document.querySelector('.sameSizeWheels').style.display = 'block';
      document.querySelector('.staggeredWheels').style.display = 'none';
    } else {
      document.querySelector('.sameSizeWheels').style.display = 'none';
      document.querySelector('.staggeredWheels').style.display = 'block';
    }
  } else {
    const index = Object.keys(wheels).indexOf(key);
    if (index > -1) {
      wheels[key] = value;
      save[key] = wheels[key];
    } else {
      const wheelObj = wheels.wheelsAndTiresSameSize ? 'sameSizeWheels' : 'differentWheels';
      wheels[wheelObj][key] = value;
      save[wheelObj] = wheels[wheelObj];
    }
  }
  saveProfile(save);
}

const makeSelection = (key, value) => {
  document.querySelectorAll(`.detailDrop[data-select="${key}"] .detailDropOptionSelection`).forEach(a => a.classList.remove('active'));
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropOptionSelection[data-value="${value}"]`).classList.add('active');
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect`).classList.remove('open');
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropOptions`).style.height = 0;
  document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect p`).textContent = value;
  if (!value) {
    document.querySelector(`.detailDrop[data-select="${key}"]`).classList.add('blank');
  } else {
    document.querySelector(`.detailDrop[data-select="${key}"]`).classList.remove('blank');
  }

  const keys = Object.keys(selections);
  const index = keys.indexOf(key);
  const nextSelection = keys[index + 1];

  keys.forEach((k, i) => {
    if (i === index) {
      selections[k] = value;
    }
    if (i > index) {
      selections[k] = '';
      document.querySelector(`.detailDrop[data-select="${k}"]`).classList.remove('active');
      document.querySelector(`.detailDrop[data-select="${k}"]`).classList.remove('blank');
      document.querySelector(`.detailDrop[data-select="${k}"] .detailDropSelect p`).textContent = 'Select ' + k[0].toUpperCase() + k.slice(1);
      if (k !== 'year') {
        document.querySelector(`.detailDrop[data-select="${k}"] .detailDropOptions`).innerHTML = '';
      }
    }
  });

  if (nextSelection) {
    document.querySelector(`.detailDrop[data-select="${nextSelection}"]`).classList.add('active');
    if (nextSelection !== 'year') {
      getNextSelections(nextSelection);
    }
  }

  setCarImage();
}

const getNextSelections = (nextSelection) => {
  let nextSelections = [];
  const indexOfNext = Object.keys(selections).indexOf(nextSelection);
  const currentSelections = Object.values(selections).slice(0, indexOfNext);
  const allNextSelections = carModelsArray.filter(arr => currentSelections.every((val, i) => arr[i] === val));
  allNextSelections.forEach(arr => {
    const value = arr[currentSelections.length];
    if (nextSelections.indexOf(value) === -1) {
      nextSelections.push(value);
    }
  });
  const container = document.querySelector(`.detailDrop[data-select="${nextSelection}"] .detailDropOptions`);
  nextSelections.forEach(val => {
    const a = document.createElement('a');
    a.dataset.value = val;
    a.textContent = val;
    a.className = 'detailDropOptionSelection';
    container.append(a);
    if (nextSelections.length === 1) {
      a.click();
    }
  });
}

const setMakes = () => {
  let makes = [];
  carModelsArray.forEach(arr => {
    const make = arr[0];
    if (makes.indexOf(make) === -1) {
      makes.push(make);
    }
  });
  const container = document.querySelector('.detailDrop[data-select="make"] .detailDropOptions');
  makes.forEach(make => {
    const a = document.createElement('a');
    a.dataset.value = make;
    a.textContent = make;
    a.className = 'detailDropOptionSelection';
    container.append(a);
  });
}

const setYears = () => {
  const latestYear = new Date().getFullYear() + 1;
  const container = document.querySelector('.detailDrop[data-select="year"] .detailDropOptions');
  for (i = latestYear; i >= 1975; i--) {
    const a = document.createElement('a');
    a.dataset.value = i;
    a.textContent = i;
    a.className = 'detailDropOptionSelection';
    container.append(a);
  }
}

const setWheelDrops = () => {
  const wheelData = JSON.parse(document.getElementById('wheelTireData').innerHTML);
  Object.keys(wheelData).forEach(key => {
    const container = document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropOptions`);
    const frontContainer = document.querySelector(`.wheelDrop[data-option="${key}Front"] .wheelDropOptions`);
    const rearContainer = document.querySelector(`.wheelDrop[data-option="${key}Rear"] .wheelDropOptions`);
    const option = wheelData[key];
    let arr = [];

    if (option.range) {
      for (let i = option.min; i <= option.max; i += option.increment) {
        arr.push(i);
      }
    } else {
      arr = option.options;
    }

    let links = '';

    arr.forEach(i => {
      let item = i + option.unit;
      if (i === 'None') {
        item = 'None';
      }
      links += `<a data-value="${item}" class="wheelDropOptionSelection">${item}</a>`;
    });

    if (key === 'wheelSpacers') {
      const dropOne = document.querySelector('.wheelDrop[data-option="frontWheelSpacers"] .wheelDropOptions');
      const dropTwo = document.querySelector('.wheelDrop[data-option="rearWheelSpacers"] .wheelDropOptions');
      dropOne.innerHTML = links;
      dropTwo.innerHTML = links;
      return;
    }

    container.innerHTML = links;
    if (frontContainer && rearContainer) {
      frontContainer.innerHTML = links;
      rearContainer.innerHTML = links;
    }
  });
}

const setCarImage = async () => {
  const currentSelections = Object.values(selections);
  currentSelections.pop();
  const allNextSelections = carModelsArray.find(arr => currentSelections.every((val, i) => arr[i] === val));
  if (!allNextSelections) {
    info.selectedCar = '';
    info.collectionHandle = '';
    return;
  }

  info.selectedCar = allNextSelections[9];
  info.collectionHandle = allNextSelections[6];

  try {
    const response = await axios.get(`/collections/${allNextSelections[6]}.json`);
    const image = response.data.collection.image;
    if (image) {
      document.querySelector('.CarProfile__carImage').innerHTML = `<img src="${image.src}" />`;
    } else {
      document.querySelector('.CarProfile__carImage').innerHTML = '';
    }
  } catch(e) {console.log('Error getting collection image', e);}
}

const setModList = list => {
  const checkSvg = `<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8.5L7 13.5L18 2" stroke="#0A76BD" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
  const xSvg = `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 9.50912L4.37116e-08 9.50912L0 6.89374L17 6.89374L17 9.50912Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.45816 -5.71622e-08L9.45816 17L6.84277 17L6.84277 0L9.45816 -5.71622e-08Z" fill="black"></path></svg>`;
  const container = document.querySelector(`.CarProfile__modList[data-mods="${list}"] .modList`);
  container.innerHTML = '';
  mods[list].forEach(mod => {
    const modItemControls = `<div class="modItem__controls"><button class="removeMod" data-value="${mod.value}">${xSvg}</button></div>`;
    const item = document.createElement('div');
    let modsLabel = '';
    let serviceLabel = '';
    let notesLabel = '';
    if(mod.modsAdded){
      modsLabel = `Mods Added: ${mod.modsAdded}<br>` 
    }
    if(mod.servicePerformed){
      serviceLabel = `Service Performed: ${mod.servicePerformed}<br>` 
    }
    if(mod.notes){
      notesLabel = `Service Performed: ${mod.notes}<br>` 
    }

    item.className = 'modItem';
    if(mod.mileage){
      item.innerHTML = `<div class="modItem__text">
      <p>
      <span>Date: ${new Date(mod.dateModified).toLocaleDateString("en-US")}</span> 
      Mileage: ${mod.mileage}</p>
      <div class='modItem__maintence-type'>
      ${modsLabel}
      ${serviceLabel}
      ${notesLabel}
      </div>
      </div>
      ${modItemControls}`;
    }else{
    	item.innerHTML = `<div class="modItem__text"><p>${mod.value}</p></div>${modItemControls}`;
    }
    container.append(item);
  });
}

const stepOneValidation = () => {
  let valid = true;
  // let fNameInput = document.querySelector('#ownerName');
  // let lNameInput = document.querySelector('#ownerLastName');
  Object.keys(selections).forEach(key => {
    if (!selections[key]) {
      const selectorNotNeeded = document.querySelector(`.detailDrop[data-select="${key}"]`).classList.contains('blank');
      if (!selectorNotNeeded) {
        document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect`).style.borderColor = 'red';
        valid = false;
      }
    } else {
      document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect`).style.borderColor = '#000';
      // JTC optimal
      if (key === 'make') {      
        // console.log('setting makes');
        if (document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect p`).innerHTML === 'VW') {
          // console.log('swapping VW for Volks');
          selections['make'] = 'Volkswagen';
        } else if (document.querySelector(`.detailDrop[data-select="${key}"] .detailDropSelect p`).innerHTML === 'Benz') {
          // console.log('swapping Benz for MB');
          selections['make'] = 'Mercedes Benz';
        }
      }
    }
  });
  // if (!checkIfInputHasValue(fNameInput)) {
  //   valid = false
  // }
  // if (!checkIfInputHasValue(lNameInput)) {
  //   valid = false
  // }
  return valid;
}

function checkIfInputHasValue(input) {
  if (input.value == '') {
    input.style.borderColor = 'red';
    return false;
  }
  input.style.borderColor = '#000';
  return true;
}

const stepTwoValidation = () => {
  let valid = true;
  const sameSize = wheels.wheelsAndTiresSameSize;
  const {frontWheelSpacers, rearWheelSpacers} = wheels;
  const wheelsInfo = sameSize ? wheels.sameSizeWheels : wheels.differentWheels;
  
  Object.keys({frontWheelSpacers, rearWheelSpacers}).forEach(key => {
    if (!wheels[key]) {
      document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropSelect`).style.borderColor = 'red';
      valid = false;
    } else {  
      document.querySelector(`.wheelDrop[data-option="${key}"] .wheelDropSelect`).style.borderColor = '#000';
    }
  });

  Object.keys(wheelsInfo).forEach(key => {
    const selector = key.indexOf('offset') > -1 ? `.wheelInput input[data-value="${key}"]` : `.wheelDrop[data-option="${key}"] .wheelDropSelect`;
    if (!wheelsInfo[key]) {
      document.querySelector(selector).style.borderColor = 'red';
      valid = false;
    } else {
      document.querySelector(selector).style.borderColor = '#000';
    }
  });
  
  return valid;
}

const stepThreeValidation = () => {
  let valid = true;
  if (images.length < 3) {
    document.querySelector('.photosError').style.display = 'block';
    valid = false;
  } else {
    document.querySelector('.photosError').style.display = 'none';
  }
  return valid;
}

const setImageView = async (index = 0) => {
  const inputBox = document.querySelector('.CarProfile__photo--itemWrap.addImageBox');
  if (index >= images.length) {
    if (images.length === 10) {
      inputBox.style.display = 'none';
    } else {
      inputBox.style.display = 'block';
    }
    imagesLoader.classList.remove('active');
    return;
  }
  const check = `<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8.5L7 13.5L18 2" stroke="#0A76BD" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>`;
  const cross = `<svg class="plus" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17 9.50912L4.37116e-08 9.50912L0 6.89374L17 6.89374L17 9.50912Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.45816 -5.71622e-08L9.45816 17L6.84277 17L6.84277 0L9.45816 -5.71622e-08Z" fill="black"></path></svg>`;
  const container = document.querySelector('.CarProfile__photos');
  const image = images[index];
  const displayImg = new Image();
  displayImg.src = HOST + image;
  const imgId = image.split(`/image/`)[1];
  const current = document.querySelector(`.savedImage[data-id="${imgId}"]`);
  if (!current) {
    await new Promise((resolve, reject) => displayImg.onload = () => resolve());
    const div = document.createElement('div');
    div.classList = `CarProfile__photo--itemWrap savedImage`;
    div.setAttribute('data-id', imgId);
    div.innerHTML = `<div class="CarProfile__photo--item"><img src="${displayImg.src}"></div><div class="CarProfile__photo--controls"><div class="check">${check}</div><button class="removeImage" data-image-id="${imgId}">${cross}</button></div>`;
    container.insertBefore(div, inputBox);
  }
  return setImageView(index + 1);
}

const saveImageFiles = async files => {
  if (files.length === 0) {
    setImageView();
    return;
  }
  try {
    const reader = new FileReader();
    const file = files.pop();
    // console.log('file', file);
    if (!file) {return saveImageFiles(files);}
    reader.readAsDataURL(file);
    reader.addEventListener('load', async () => {
      const image = new Image();
      // console.log('image', image);
      image.src = reader.result;
      // console.log('image', image, reader);
      image.crossOrigin = 'Anonymous';
      await new Promise((resolve, reject) => image.onload = () => resolve());
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const newWidth = 1000;
      const aspectRatio = image.width / image.height;
      const newHeight = newWidth / aspectRatio;
      image.width = newWidth;
      image.height = newHeight
      canvas.width = newWidth;
      canvas.height = newHeight;
      ctx.drawImage(image, 0, 0, image.width, image.height);
      const saveUnwatermarkedImage = canvas.toDataURL();
      const x = canvas.width - watermark.width - 30;
      const y = canvas.height - watermark.height - 30;
      ctx.drawImage(watermark, x, y, watermark.width, watermark.height);
      const save = canvas.toDataURL();
      canvas.remove();
      const variables = {id: ID, image: save, unwatermarkedImage: saveUnwatermarkedImage};
      const response = await axios.post(`${HOST}/customer_graphql`, {query: ADD_IMAGE, variables}, {headers});
      const savedImageLink = response.data.data;
      images.push(savedImageLink.addImage);
      return saveImageFiles(files);
    });

  } catch(e) {console.log('Error saving image', e);}
}

const removeImage = async image => {
  try {
    await axios.post(`${HOST}/customer_graphql`, {query: REMOVE_IMAGE, variables: {id: ID, image}}, {headers});
  } catch(e) {console.log('Error removing image', e);}
}

var picker = new Pikaday({ field: document.getElementById('datepicker') });
// Car mods event listeners
document.querySelectorAll('.modListForm').forEach(form => form.addEventListener('submit', async e => {
  e.preventDefault();
  const input = form.querySelector('input');
  // const mileageInput = form.querySelector('#mileage');
  // const servicePerformedInput = form.querySelector('#servicePerformed');
  // const modsAddedInput = form.querySelector('#modsAdded');
  // const notesInput = form.querySelector('#notes');
  const list = form.closest('.CarProfile__modList').dataset.mods;
  
  // if(list == 'maintenanceMods'){
  //   const modInput = {mileage: mileageInput.value, servicePerformed: servicePerformedInput.value, modsAdded: modsAddedInput.value, notes: notesInput.value, dateModified: picker.getDate() , list};
  //   mods[list].push({mileage: mileageInput.value, servicePerformed: servicePerformedInput.value, modsAdded: modsAddedInput.value, notes: notesInput.value, dateModified: picker.getDate() });
  //   input.value = '';
  //   input.focus();
  //   setModList(list);
  //   try {
  //     await axios.post(`${HOST}/customer_graphql`, {query: ADD_MAINT, variables: {id: ID, input: modInput}}, {headers});
  //   } catch(e) {console.log('Error adding mod', e);}
  // }
	// else {
    if (input.value) {
      const index = mods[list].findIndex(m => m.value === input.value);
      if (index > -1) {return;}
      const modInput = {value: input.value, list};
      mods[list].push({value: input.value});
      input.value = '';
      input.focus();
      setModList(list);

      try {
        await axios.post(`${HOST}/customer_graphql`, {query: ADD_MOD, variables: {id: ID, input: modInput}}, {headers});
      } catch(e) {console.log('Error adding mod', e);}
    }  
	// }
  
}));

// Car detail event listeners
document.querySelectorAll('.detailDropSelect').forEach(btn => btn.addEventListener('click', e => {
  e.preventDefault();
  const container = e.currentTarget.closest('.detailDrop');
  const drop = container.querySelector('.detailDropOptions');
  if (e.currentTarget.classList.contains('open')) {
    e.currentTarget.classList.remove('open');
    drop.style.height = 0;
  } else {
    e.currentTarget.classList.add('open');
    drop.style.height = drop.scrollHeight + 'px';
  }
}));

document.querySelector('.CarProfile__carDetails').addEventListener('click', e => {
  if (e.target.classList.contains('detailDropOptionSelection')) {
    e.preventDefault();
    const key = e.target.closest('.detailDrop').dataset.select;
    makeSelection(key, e.target.dataset.value);
  }
});

// Car mods event listeners
document.querySelectorAll('.modListForm').forEach(form => form.addEventListener('submit', async e => {
  e.preventDefault();
  const input = form.querySelector('input');
  const list = form.closest('.CarProfile__modList').dataset.mods;
  if (input.value) {
    const index = mods[list].findIndex(m => m.value === input.value);
    if (index > -1) {return;}
    const modInput = {value: input.value, list};
    mods[list].push({value: input.value});
    input.value = '';
    input.focus();
    setModList(list);

    try {
      await axios.post(`${HOST}/customer_graphql`, {query: ADD_MOD, variables: {id: ID, input: modInput}}, {headers});
    } catch(e) {console.log('Error adding mod', e);}
  }
}));

document.querySelectorAll('.CarProfile__modList').forEach(list => list.addEventListener('click', async e => {
  if (e.target.classList.contains('removeMod')) {
    e.preventDefault();
    const modList = list.dataset.mods;
    const value = e.target.dataset.value;
    const modInput = {value, list: modList};
    const index = mods[modList].findIndex(m => m.value === value);
    mods[modList].splice(index, 1);
    setModList(modList);
    try {
      await axios.post(`${HOST}/customer_graphql`, {query: REMOVE_MOD, variables: {id: ID, input: modInput}}, {headers});
    } catch(e) {console.log('Error removing mod', e);}
  }
}));

// Car wheel event listeners
document.querySelectorAll('.wheelDropSelect').forEach(btn => btn.addEventListener('click', e => {
  e.preventDefault();
  const container = e.currentTarget.closest('.wheelDrop');
  const drop = container.querySelector('.wheelDropOptions');
  if (e.currentTarget.classList.contains('open')) {
    e.currentTarget.classList.remove('open');
    drop.style.height = 0;
  } else {
    e.currentTarget.classList.add('open');
    drop.style.height = drop.scrollHeight + 'px';
  }
}));

document.querySelector('.CarProfile__wheels').addEventListener('click', e => {
  if (e.target.classList.contains('wheelDropOptionSelection')) {
    e.preventDefault();
    const key = e.target.closest('.wheelDrop').dataset.option;
    makeWheelSelection(key, e.target.dataset.value);
  }
});

let saveOffsets;
let saveWheelAndTireBrandings;

document.querySelectorAll('.wheelInput.offsetInput input').forEach(input => input.addEventListener('input', e => {
  clearTimeout(saveOffsets);
  const save = {};
  const wheelObj = wheels.wheelsAndTiresSameSize ? 'sameSizeWheels' : 'differentWheels';
  save[wheelObj] = wheels[wheelObj];
  if (wheelObj === 'differentWheels') {
    const offsetFrontValue = document.querySelector('.wheelInput.offsetInput input[data-value="offsetFront"]').value;
    const offsetRearValue = document.querySelector('.wheelInput.offsetInput input[data-value="offsetRear"]').value;
    wheels[wheelObj].offsetFront = offsetFrontValue;
    wheels[wheelObj].offsetRear = offsetRearValue;
    save[wheelObj].offsetFront = offsetFrontValue;
    save[wheelObj].offsetRear = offsetRearValue;
  } else {
    const offsetValue = document.querySelector('.wheelInput.offsetInput input[data-value="offset"]').value;
    wheels[wheelObj].offset = offsetValue;
    save[wheelObj].offset = offsetValue;
  }
  saveOffsets = setTimeout(() => saveProfile(save), 1000);
  // console.log('after offset saves', selections);
}));

document.querySelectorAll('.wheelInput.wheelBranding input').forEach(input => input.addEventListener('input', e => {
  clearTimeout(saveWheelAndTireBrandings);
  const save = {};
  const wheelBrandOrModelValue = document.querySelector('.wheelInput.wheelBranding input[data-value="wheelBrandOrModel"]').value;
  const tireBrandOrModelValue = document.querySelector('.wheelInput.wheelBranding input[data-value="tireBrandOrModel"]').value;
  wheels.wheelBrandOrModel = wheelBrandOrModelValue;
  wheels.tireBrandOrModel = tireBrandOrModelValue;
  save.wheelBrandOrModel = wheelBrandOrModelValue;
  save.tireBrandOrModel = tireBrandOrModelValue;
  saveWheelAndTireBrandings = setTimeout(() => saveProfile(save), 1000);
}));

// Car image event listeners
document.querySelector('#imageFileUploader').addEventListener('change', e => {
  imagesLoader.classList.add('active');
  const difference = 10 - images.length;
  const files = e.target.files;
  const fileList = Array.prototype.slice.call(files, 0, difference);
  saveImageFiles(fileList.reverse());
});

document.querySelector('.CarProfile__photos').addEventListener('click', e => {
  if (e.target.classList.contains('removeImage')) {
    e.preventDefault();
    const imgId = e.target.dataset.imageId;
    const index = images.findIndex(name => name.indexOf(imgId) > -1);
    const image = images[index];
    images.splice(index, 1);
    document.querySelector(`.savedImage[data-id="${imgId}"]`).remove();
    document.querySelector('.CarProfile__photo--itemWrap.addImageBox').style.display = 'block';
    removeImage(image);
  }
});

let savePhotographerIgName;

document.getElementById('photographerIgName').addEventListener('input', e => {
  clearTimeout(savePhotographerIgName);
  photographerIg = e.target.value;
  savePhotographerIgName = setTimeout(() => saveProfile({photographerIg}), 1000);
});

// let saveOwnerFirstName;
// let saveOwnerLastName;

// document.getElementById('ownerName').addEventListener('input', e => {
//   clearTimeout(saveOwnerFirstName);
//   firstName = e.target.value;
//   saveOwnerFirstName = setTimeout(() => saveProfile({firstName}), 1000);
// });

// document.getElementById('ownerLastName').addEventListener('input', e => {
//   clearTimeout(saveOwnerLastName);
//   lastName = e.target.value;
//   saveOwnerLastName = setTimeout(() => saveProfile({lastName}), 1000);
// });

// Navigation button eventlisteners
document.querySelector('.prev').addEventListener('click', () => {
  if (activeStep === 1) {return;}
  activeStep--;
  setActiveStep();
  pushToHistory();
});

document.querySelector('.next').addEventListener('click', () => {
  if (activeStep === 1) {
    const stepOneValid = stepOneValidation();
    if (!stepOneValid) {return;}
    // JTC
    saveProfile({...selections, ...info});
    // console.log('selections after save', selections);
    activeStep = 2;
    setActiveStep();
    pushToHistory();
  } else if (activeStep === 2) {
    // const stepTwoValid = stepTwoValidation();
    // if (!stepTwoValid) {return;}
    activeStep = 3;
    setActiveStep();
    pushToHistory();
  } else if (activeStep === 3) {
    const stepThreeValid = stepThreeValidation();
    if (!stepThreeValid) {return};
    activeStep = 4;
    setStepFour();
    setActiveStep();
    pushToHistory();
  } else if (activeStep === 4) {
    activeStep = 5;
    setStepFour();
    setActiveStep();
    pushToHistory();
  }
});

document.querySelector('.completeSubmission').addEventListener('click', async () => {
  const agree = document.getElementById('agreeToTerms').checked;
  if (!agree) {return;}
  const SUBMIT_PROFILE = `
    mutation submitProfile($id: ID!) {
      submitProfile(id: $id)
    }
  `;
  try {
    await axios.post(`${HOST}/customer_graphql`, {query: SUBMIT_PROFILE, variables: {id: ID}}, {headers});
    return window.location.href = '/account';
  } catch(e) {console.log('Error submiting for approval', e);}
});

setMakes();
setYears();
setWheelDrops();
setActiveStep();
getProfile();

window.addEventListener('popstate', e => {
  activeStep = e.state ? e.state.step : 1;
  if (activeStep === 4) {
    if (images.length > 0) {
      setStepFour();
    } else {
      activeStep = 1;
    }
  }
  setActiveStep();
});
